﻿import { Global } from "@emotion/react";
import { FC } from "react";

/**
 * Use this component just inside your ChakraProvider to add the font faces that the theme uses.
 *
 * ```
 * <ChakraProvider theme={theme} resetCSS>
 *  <Fonts />
 *  ...
 * </ChakraProvider>
 * ```
 */
export const Fonts: FC<{ assetsPath?: string }> = ({ assetsPath = "/assets/fonts" }) => (
    /*
     * The css below should be copied from index.css. Don't edit here. Edit in index.css and copy here.
     */
    <Global
        styles={`
/* DIN */
@font-face {
    font-family: "DIN Condensed";
    font-weight: 400;
    src: url("${assetsPath}/DINNextW01-CondensedMed.woff2") format("woff2");
}



/* Helvetica Neue */
@font-face {
    font-family: "Helvetica Neue";
    font-weight: 300;
    src: url("${assetsPath}/HelveticaNeueLTStd-Lt.woff2") format("woff2"), url("${assetsPath}/HelveticaNeueLTStd-Lt.otf") format("opentype");
}

@font-face {
    font-family: "Helvetica Neue";
    font-weight: 400;
    src: url("${assetsPath}/HelveticaNeueLTStd-Roman.woff2") format("woff2"), url("${assetsPath}/HelveticaNeueLTStd-Roman.otf") format("opentype");
}

@font-face {
    font-family: "Helvetica Neue";
    src: url("${assetsPath}/HelveticaNeueLTStd-Md.woff2") format("woff2"), url("${assetsPath}/HelveticaNeueLTStd-Md.otf") format("opentype");
    font-weight: 500;
}

@font-face {
    font-family: "Helvetica Neue";
    font-weight: 700;
    src: url("${assetsPath}/HelveticaNeueLTStd-Bd.woff2") format("woff2"), url("${assetsPath}/HelveticaNeueLTStd-Bd.otf") format("opentype");
}



/* Helvetica Neue Condensed */
@font-face {
    font-family: "Helvetica Neue Condensed";
    font-weight: 300;
    src: url("${assetsPath}/HelveticaNeueLTStd-LtCn.woff2") format("woff2"), url("${assetsPath}/HelveticaNeueLTStd-LtCn.otf") format("opentype");
}

@font-face {
    font-family: "Helvetica Neue Condensed";
    font-weight: 400;
    src: url("${assetsPath}/HelveticaNeueLTStd-Cn.woff2") format("woff2"), url("${assetsPath}/HelveticaNeueLTStd-Cn.otf") format("opentype");
}

@font-face {
    font-family: "Helvetica Neue Condensed";
    font-weight: 500;
    src: url("${assetsPath}/HelveticaNeueLTStd-MdCn.woff2") format("woff2"), url("${assetsPath}/HelveticaNeueLTStd-MdCn.otf") format("opentype");
}

@font-face {
    font-family: "Helvetica Neue Condensed";
    font-weight: 700;
    src: url("${assetsPath}/HelveticaNeueLTStd-BdCn.woff2") format("woff2"), url("${assetsPath}/HelveticaNeueLTStd-BdCn.otf") format("opentype");
}

@font-face {
    font-family: "Helvetica Neue Condensed";
    font-weight: 900;
    src: url("${assetsPath}/HelveticaNeueLTStd-HvCn.woff2") format("woff2"), url("${assetsPath}/HelveticaNeueLTStd-HvCn.otf") format("opentype");
}



/* Helvetica Neue Extra */
@font-face {
    font-family: "Helvetica Neue Extra";
    font-weight: 300;
    src: url("${assetsPath}/HelveticaNeueLTStd-LtEx.woff2") format("woff2"), url("${assetsPath}/HelveticaNeueLTStd-LtEx.otf") format("opentype");
}

@font-face {
    font-family: "Helvetica Neue Extra";
    font-weight: 400;
    src: url("${assetsPath}/HelveticaNeueLTStd-Ex.woff2") format("woff2"), url("${assetsPath}/HelveticaNeueLTStd-Ex.otf") format("opentype");
}
      `}
    />
);
